<template>
  <ProductDetails
    v-bind="$attrs"
    :key="forcedRerender"
    @hydrated="
      () => {
        unWatchComponentRefresh?.(); // destroy watcher if component is already hydrated
      }
    "
  />
</template>
<script lang="ts" setup>
import { defineLazyVisibleHydratedComponent } from '@nuxt-common/media-card-large/app/modules/lazy-hydration';
import useTriggerComponentRefreshOnce from '../composables/useTriggerComponentRefreshOnce';
import { useProductType } from '~/composables/useProductType';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';
import useUpc from '~/modules/upc/composables/useUpc';

defineOptions({
  inheritAttrs: false,
});

const { forcedRerender, unWatchComponentRefresh, setComponentRefreshWatcher } = useTriggerComponentRefreshOnce();
const { isConsolidatedStandard } = useProductType();
const { isShopTheSetExpEnabled } = useFeatureEligibility();

if (isShopTheSetExpEnabled) {
  const selectedProdId = useSelectedMemberId();
  setComponentRefreshWatcher(() => selectedProdId.value);
} else if (isConsolidatedStandard) {
  const { selectedUpcId } = useUpc();
  setComponentRefreshWatcher(() => selectedUpcId.value);
}

const ProductDetails = defineLazyVisibleHydratedComponent(() => import('~/modules/productDetails/components/ProductDetails.vue'));
</script>
